<template>
  <div class="main-content-shell">
    <main class="main-content">
      <component
        :is="currentComponent"
        v-bind="currentComponentProps"
        v-on="currentComponentEvents"
      />
    </main>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import CreationPage from '../uploader/CreationPage.vue'
import HomePage from '../home/HomePage.vue'
import AudioPlayer from '../player/AudioPlayer.vue'
import RecentFiles from './RecentFiles.vue'
import MaterialLibrary from '../materials/MaterialLibrary.vue'
import MaterialCategory from '../materials/MaterialCategory.vue'
import CheckIn from '../common/CheckIn.vue'
import LearningRecords from '../learning/LearningRecords.vue'
import VocabularyBook from '../learning/VocabularyBook.vue'
import ReferralPage from '../referral/ReferralPage.vue'
import LearnerProfilePage from '../profile/LearnerProfilePage.vue'
import LevelTestPage from '../levelTest/LevelTestPage.vue'
import { useViews } from '@/composables/views'

export default {
  name: 'MainContent',
  components: {
    HomePage,
    AudioPlayer,
    RecentFiles,
    MaterialLibrary,
    MaterialCategory,
    CheckIn,
    LearningRecords,
    VocabularyBook,
    ReferralPage,
    LearnerProfilePage,
    LevelTestPage
  },
  setup() {
    const route = useRoute()
    const { currentView, contentProps } = useViews()

    const currentComponent = computed(() => {
      switch (currentView.value) {
        case 'Creation':
          return CreationPage
        case 'AudioPlayer':
          return AudioPlayer
        case 'RecentFiles':
          return RecentFiles
        case 'Material':
          return route.params.id ? MaterialCategory : MaterialLibrary
        case 'CheckIn':
          return CheckIn
        case 'LearningRecords':
          return LearningRecords
        case 'VocabularyBook':
          return VocabularyBook
        case 'Referral':
          return ReferralPage
        case 'Profile':
          return LearnerProfilePage
        case 'LevelTest':
          return LevelTestPage
        default:
          return HomePage
      }
    })

    // AudioPlayer 需要的音频相关 props
    const currentComponentProps = computed(() => {
      if (currentView.value === 'Creation') return { tool: contentProps.value.tool || 'transcribe' }
      if (currentView.value === 'AudioPlayer') {
        return {
          audioSrc: contentProps.value.audioSrc,
          videoSrc: contentProps.value.videoSrc,
          youtubeVideoId: contentProps.value.youtubeVideoId,
          posterSrc: contentProps.value.posterSrc,
          cover: contentProps.value.cover,
          audioId: contentProps.value.audioId,
          audioName: contentProps.value.audioName,
          materialId: contentProps.value.materialId,
          materialBook: contentProps.value.materialBook,
          allowAudioDownload: contentProps.value.allowAudioDownload,
          originalSubtitles: contentProps.value.originalSubtitles,
          subtitles: contentProps.value.subtitles,
          practiceSubtitles: contentProps.value.practiceSubtitles,
          shortPracticeSubtitles: contentProps.value.shortPracticeSubtitles,
          pauseSubtitles: contentProps.value.pauseSubtitles,
          completeSubtitles: contentProps.value.completeSubtitles,
          words: contentProps.value.words,
          demoTranslations: contentProps.value.demoTranslations,
          useSmartSplit: contentProps.value.useSmartSplit,
          originalText: contentProps.value.originalText,
          taskType: contentProps.value.taskType,
          filePath: contentProps.value.filePath,
          duration: contentProps.value.duration,
          isDemo: contentProps.value.isDemo,
          returnView: contentProps.value.returnView,
          returnParams: contentProps.value.returnParams,
          focusSentence: contentProps.value.focusSentence,
          tourRequest: contentProps.value.tourRequest
        }
      }
      return {}
    })

    // 仍需处理的事件（内容更新类）
    const currentComponentEvents = computed(() => {
      if (currentView.value === 'AudioPlayer') {
        return {
          'subtitles-updated': (subtitles) => {
            contentProps.value = { ...contentProps.value, subtitles: [...subtitles] }
          },
          'file-updated': (fileData) => {
            contentProps.value = { ...contentProps.value, ...fileData }
          },
          'update:taskType': (type) => {
            contentProps.value = { ...contentProps.value, taskType: type }
          },
          'show-message': (message) => {
            if (message.type === 'error') ElMessage.error(message.message)
            else if (message.type === 'success') ElMessage.success(message.message)
          }
        }
      }
      if (currentView.value === 'Material') {
        return {
          'show-message': (message) => {
            if (message.type === 'error') ElMessage.error(message.message)
            else if (message.type === 'success') ElMessage.success(message.message)
          }
        }
      }
      return {}
    })

    return {
      currentView,
      currentComponent,
      currentComponentProps,
      currentComponentEvents
    }
  }
}
</script>

<style scoped>
.main-content-shell {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
  padding: 0;
  position: relative;
  min-width: 0;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;
  min-width: 0;
}

@media (max-width: 768px) {
  .main-content {
    padding: 0;
  }
}
</style>
